import AdminLayout from "../../../components/admin/layout/AdminLayout";
import { useLocation } from "react-router-dom";
import CreateSurvey from "../../../components/common/survey/CreateSurvey";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";

function SurveyEditPage() {
  const { userType } = useAuthStore();
  const location = useLocation();
  const editData = location.state || {};

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <CreateSurvey editData={editData} />
    </AdminLayout>
  );
}

export default SurveyEditPage;
